module.exports = __webpack_public_path__ + "assets/keypad-sounds/bingbing-11e629c2d69dcfce9e1d606660715b90.wav";